

















































import {
    myVue
} from "@/components/class/myVue";
import {
    Component
} from "vue-property-decorator";
import * as utils from "@/components/util/utils";
@Component
export default class HelloWorld extends myVue {
    add() {
        this.current.add();
    }
    setIndex(edit_index: any) {
        for (let i = 0; i < this.current.components["template" + edit_index].length; i++) {
            if (
                this.current.components["template" + edit_index][i].show_type == "编辑"
            ) {
                this.current.components["template" + edit_index][i].show_type = "详情";
            } else {
                this.current.components["template" + edit_index][i].show_type = "编辑";
            }
        }
    }
    solveIndex(edit_index: any) {
        for (let i = 0; i < this.current.components["template" + edit_index].length; i++) {
            if (
                this.current.components["template" + edit_index][i].show_type == "编辑"
            ) {
                this.current.components["template" + edit_index][i].show_type = "详情";
                if (this.current.components["template" + edit_index][i].label == "id") {
                    let id = this.current.components["template" + edit_index][i].value;
                    utils.my_post({
                        apiName: "/applet/saveHistoryProblem",
                        params: {
                            id: id,
                        },
                        ok: (json: any, dataAll: any) => {
                            utils.myMessage({
                                message: "已解决"
                            })
                        },
                        err: (json: any, dataAll: any) => {
                            utils.myMessage({
                                message: "请求异常",
                                level: "warning"
                            })
                        },
                    });
                }
            } else {
                this.current.components["template" + edit_index][i].show_type = "编辑";
            }
        }
    }
    reIndex(edit_index: any) {
        let newValue: any[] = JSON.parse(this.current.valueFormat());
        if (utils.isNull(newValue)) {
            newValue = utils.lodash.cloneDeep(this.current.value);
        }
        utils.lodash.pullAt(newValue, edit_index);
        this.current.value = newValue;
    }
    historyList(edit_index: any) {
        utils.lodash.pullAt(this.current.value, edit_index);
        this.current.initCopyComponents();
    }
}
